define('ImageGalleryCloudinary.EntryPoint'
  , [
    'Item.Model',
    'Transaction.Line.Model',
    'ProductList.DetailsLaterMacro.View',
    'ItemsSearcher.Item.View',
    'Configuration',
    'Utils'
  ]
  , function (
    ItemModel,
    TransactionLineModel,
    ProductListDetailsLaterMacroView,
    ItemsSearcherItemView,
    Configuration,
    Utils
  ) {
    'use strict';

    return {
      mountToApp: function mountToApp(container) {
        var environment = container.getComponent('Environment');
        var domainSiteField = environment && environment.getConfig('cloudinaryImageGallery.field');
        var manuallyImg = environment && environment.getConfig('cloudinaryImageGallery.defaultfield');
        var folderPathName = environment && environment.getConfig('cloudinaryImageGallery.notFoundFolder');

        var published = SC.published || SC.ENVIRONMENT.published;
        var notFoundImages = published && published.Categories;
        var domain = environment && environment.getSiteSetting().touchpoints.home;
        var fileRoute = domain + folderPathName;
        _.extend(ItemModel.prototype, {

          getThumbnail: function getThumbnail() {
            var commercecategory = this.get('commercecategory');
            commercecategory = commercecategory && _.last(commercecategory.primarypath);
            var cloudinaryImages = this.get(domainSiteField) ? this.get(domainSiteField).split(';') : '';
            var cloudinaryImagesDetail = [];
            if (!cloudinaryImages) {
              cloudinaryImages = this.get(manuallyImg) ? this.get(manuallyImg).split(';') : '';
            }
            _.map(cloudinaryImages, function (element) {
              if (cloudinaryImagesDetail.length === 0) {
                cloudinaryImagesDetail = [{
                  altimagetext: '',
                  url: element
                }];
              } else {
                cloudinaryImagesDetail.push({
                  altimagetext: '',
                  url: element
                });
              }
            });
            if (cloudinaryImagesDetail.length > 0) {
              return _.first(cloudinaryImagesDetail);
            }
            var notFoundImage = commercecategory && _.find(notFoundImages, function (element) {
              return parseInt(element.id) === parseInt(commercecategory.id);
            });
            if (notFoundImage) {
              return {
                url: fileRoute + notFoundImage.name,
                altimagetext: ''
              };
            }
            return this.get('_thumbnail');
          },

          getImages: function getImages() {
            var result = [];

            var cloudinaryImages = this.get(domainSiteField) ? this.get(domainSiteField).split(';') : '';
            var cloudinaryImagesDetail = [];
            if (!cloudinaryImages) {
              cloudinaryImages = this.get(manuallyImg) ? this.get(manuallyImg).split(';') : '';
            }
            _.map(cloudinaryImages, function (element) {
              if (cloudinaryImagesDetail.length === 0) {
                cloudinaryImagesDetail = [{
                  altimagetext: '',
                  url: element
                }];
              } else {
                cloudinaryImagesDetail.push({
                  altimagetext: '',
                  url: element
                });
              }
            });

            if (cloudinaryImagesDetail.length > 0) {
              return cloudinaryImagesDetail;
            }

            var commercecategory = this.get('commercecategory');
            commercecategory = commercecategory && _.last(commercecategory.primarypath);
            var notFoundImage = commercecategory && _.find(notFoundImages, function (element) {
              return parseInt(element.id) === parseInt(commercecategory.id);
            });
            if (notFoundImage) {
              return [{
                altimagetext: '',
                url: fileRoute + notFoundImage.name
              }];
            }
            return result.length
              ? result
              : [
                {
                  // @property {String} url
                  url: Utils.getThemeAbsoluteUrlOfNonManagedResources(
                    'img/no_image_available.jpeg',
                    Configuration.get('imageNotAvailable')
                  ),
                  // @property {String} altimagetext
                  altimagetext: this.get('_name')
                }
              ];
            // @class Item.Model
          }

        });

        _.extend(ProductListDetailsLaterMacroView.prototype, {
          getContext: _.wrap(ProductListDetailsLaterMacroView.prototype.getContext, function (fn) {
            var ctx = fn.apply(this, _.toArray(arguments).slice(1));

            if (ctx.model) {
              var commercecategory = ctx.model.get('commercecategory') || ctx.model.getItem().get('commercecategory');
              commercecategory = commercecategory && _.last(commercecategory.primarypath);

              var cloudinaryImages = ctx.model.get(domainSiteField) ? ctx.model.get(domainSiteField).split(';') : '';
              if (!cloudinaryImages) {
                if (ctx.model.getItem) {
                  cloudinaryImages = ctx.model.getItem() && ctx.model.getItem().get(domainSiteField) ? ctx.model.getItem().get(domainSiteField).split(';') : '';
                } else {
                  cloudinaryImages = ctx.model.get(domainSiteField) ? ctx.model.get(domainSiteField).split(';') : '';
                }
              }
              if (!cloudinaryImages) {
                if (this.get) {
                  cloudinaryImages = this.get(manuallyImg) ? this.get(manuallyImg).split(';') : '';
                } else if (ctx.model.getItem) {
                  cloudinaryImages = ctx.model.getItem() && ctx.model.getItem().get(manuallyImg) ? ctx.model.getItem().get(manuallyImg).split(';') : '';
                } else {
                  cloudinaryImages = ctx.model.get(manuallyImg) ? ctx.model.get(manuallyImg).split(';') : '';
                }
              }
              var cloudinaryImagesDetail = [];
              _.map(cloudinaryImages, function (element) {
                if (cloudinaryImagesDetail.length === 0) {
                  cloudinaryImagesDetail = [{
                    altimagetext: '',
                    url: element
                  }];
                } else {
                  cloudinaryImagesDetail.push({
                    altimagetext: '',
                    url: element
                  });
                }
              });
              if (cloudinaryImagesDetail.length) {
                // ctx.model.set('_thumbnail', _.first(cloudinaryImagesDetail));
                // ctx.model.getItem && ctx.model.getItem().set('_thumbnail', _.first(cloudinaryImagesDetail));
                ctx.thumbnail = _.first(cloudinaryImagesDetail);

                return ctx;
              }
              var notFoundImage = commercecategory && _.find(notFoundImages, function (element) {
                return parseInt(element.id) === parseInt(commercecategory.id);
              });
              if (notFoundImage) {
                var notFoundUrl = {
                  altimagetext: '',
                  url: fileRoute + notFoundImage.name
                };

                // ctx.model.get('_thumbnail') ? ctx.model.set('_thumbnail', notFoundUrl) : ctx.model.getItem().set('_thumbnail', notFoundUrl);
                // ctx.model.getItem && ctx.model.getItem().set('_thumbnail', notFoundUrl);
                ctx.thumbnail = notFoundUrl;
                return ctx;
              }
            }

            return ctx;
          })
        });

        _.extend(ItemsSearcherItemView.prototype, {
          getContext: _.wrap(ItemsSearcherItemView.prototype.getContext, function (fn) {
            var ctx = fn.apply(this, _.toArray(arguments).slice(1));
            if (ctx.model) {
              var commercecategory = ctx.model.get('commercecategory') || ctx.model.getItem().get('commercecategory');
              commercecategory = commercecategory && _.last(commercecategory.primarypath);

              var cloudinaryImages = ctx.model.get(domainSiteField) ? ctx.model.get(domainSiteField).split(';') : '';
              if (!cloudinaryImages) {
                cloudinaryImages = ctx.model.get(manuallyImg) ? ctx.model.get(manuallyImg).split(';') : '';
              }
              if (!cloudinaryImages) {
                if (ctx.model.getItem) {
                  cloudinaryImages = ctx.model.getItem().get(domainSiteField) ? ctx.model.getItem().get(domainSiteField).split(';') : '';
                } else {
                  cloudinaryImages = ctx.model.get(domainSiteField) ? ctx.model.get(domainSiteField).split(';') : '';
                }
              }
              var cloudinaryImagesDetail = [];
              _.map(cloudinaryImages, function (element) {
                if (cloudinaryImagesDetail.length === 0) {
                  cloudinaryImagesDetail = [{
                    altimagetext: '',
                    url: element
                  }];
                } else {
                  cloudinaryImagesDetail.push({
                    altimagetext: '',
                    url: element
                  });
                }
              });
              if (cloudinaryImagesDetail.length) {
                ctx.model.set('_thumbnail', _.first(cloudinaryImagesDetail));
                ctx.model.getItem && ctx.model.getItem().set('_thumbnail', _.first(cloudinaryImagesDetail));
                ctx.thumbnailcloudinary = _.first(cloudinaryImagesDetail);

                return ctx;
              }
              var notFoundImage = commercecategory && _.find(notFoundImages, function (element) {
                return parseInt(element.id) === parseInt(commercecategory.id);
              });
              if (notFoundImage) {
                var notFoundUrl = {
                  altimagetext: '',
                  url: fileRoute + notFoundImage.name
                };

                ctx.model.get('_thumbnail') ? ctx.model.set('_thumbnail', notFoundUrl) : ctx.model.getItem().set('_thumbnail', notFoundUrl);
                ctx.model.getItem && ctx.model.getItem().set('_thumbnail', notFoundUrl);
                ctx.thumbnailcloudinary = notFoundUrl;
                return ctx;
              }
            }
            return ctx;
          })
        });

        _.extend(TransactionLineModel.prototype, {

          getThumbnail: function getThumbnail() {
            var item = this.get('item');
            var cloudinaryImages = item.get(domainSiteField) ? item.get(domainSiteField).split(';') : '';
            var cloudinaryImagesDetail = [];
            if (!cloudinaryImages) {
              cloudinaryImages = item.get(manuallyImg) ? item.get(manuallyImg).split(';') : '';
            }
            _.map(cloudinaryImages, function (element) {
              if (cloudinaryImagesDetail.length === 0) {
                cloudinaryImagesDetail = [{
                  altimagetext: '',
                  url: element
                }];
              } else {
                cloudinaryImagesDetail.push({
                  altimagetext: '',
                  url: element
                });
              }
            });

            if (cloudinaryImagesDetail.length > 0) {
              return _.first(cloudinaryImagesDetail);
            }

            var commercecategory = item.get('commercecategory');
            commercecategory = commercecategory && _.last(commercecategory.primarypath);
            var notFoundImage = commercecategory && _.find(notFoundImages, function (element) {
              return parseInt(element.id) === parseInt(commercecategory.id);
            });
            if (notFoundImage) {
              return {
                altimagetext: '',
                url: fileRoute + notFoundImage.name
              };
            }

            return {
              url: Utils.getThemeAbsoluteUrlOfNonManagedResources(
                'img/no_image_available.jpeg',
                environment.getConfig('imageNotAvailable')
              ),
              altimagetext: this.get('_name')
            };
          }
        });

      }
    };
  });
